var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseBid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.165039,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#DCFCE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1652 18.6665H24.1652C23.458 18.6665 22.7797 18.9475 22.2796 19.4476C21.7795 19.9476 21.4985 20.6259 21.4985 21.3332V42.6665C21.4985 43.3737 21.7795 44.052 22.2796 44.5521C22.7797 45.0522 23.458 45.3332 24.1652 45.3332H40.1652C40.8724 45.3332 41.5507 45.0522 42.0508 44.5521C42.5509 44.052 42.8319 43.3737 42.8319 42.6665V25.3332L36.1652 18.6665Z",
    stroke: "url(#paint0_linear_401_1609)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8315 18.6665V23.9998C34.8315 24.7071 35.1125 25.3854 35.6126 25.8855C36.1127 26.3856 36.791 26.6665 37.4982 26.6665H42.8315",
    stroke: "url(#paint1_linear_401_1609)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4982 28H26.8315",
    stroke: "url(#paint2_linear_401_1609)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4982 33.3335H26.8315",
    stroke: "url(#paint3_linear_401_1609)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4982 38.6665H26.8315",
    stroke: "url(#paint4_linear_401_1609)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_1609",
    x1: 21.4985,
    y1: 31.9998,
    x2: 42.8319,
    y2: 31.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_401_1609",
    x1: 34.8315,
    y1: 22.6665,
    x2: 42.8315,
    y2: 22.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_401_1609",
    x1: 26.8315,
    y1: 28.5,
    x2: 29.4982,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_401_1609",
    x1: 26.8315,
    y1: 33.8335,
    x2: 37.4982,
    y2: 33.8335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_401_1609",
    x1: 26.8315,
    y1: 39.1665,
    x2: 37.4982,
    y2: 39.1665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseBid);
export default __webpack_public_path__ + "static/media/browse-bid.bc83997441a90ad939c94c2f1af0316e.svg";
export { ForwardRef as ReactComponent };